export const fontImports = [
    {
        family: 'DeLonghiSans',
        folder: 'delonghi',
        variants: [
            {
                name: 'Regular',
                weight: 400,
            },
            {
                name: 'Medium',
                weight: 500,
            },
            {
                name: 'Bold',
                weight: 700,
            },
        ],
    },
    {
        family: 'DeLonghiSerif',
        folder: 'delonghi',
        variants: [
            {
                name: 'Regular',
                weight: 400,
            },
            {
                name: 'Medium',
                weight: 500,
            },
        ],
    },
    {
        family: 'NotoSans',
        folder: 'global',
        variants: [
            {
                name: 'Regular',
                weight: 400,
            },
            {
                name: 'Bold',
                weight: 700,
            },
        ],
    },
]
